import React, { useState } from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Carousel from 'react-material-ui-carousel';

const useStyles = makeStyles(theme => ({
    imageList: {
        width: '100%',
        marginTop: '12px',
        display: 'flex',
        flexWrap: 'nowrap',
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
        overflowX: 'auto'
    },
    sliderImage: {
        maxHeight: 'calc(100vh - 280px)'
    },
    thumbnailImage: {
        height: '150px',
        marginRight: '4px',
        cursor: 'pointer',
        opacity: 0.6,
        '&:hover': {
            opacity: 1
        },
        '&.active': {
            opacity: 1
        }
    },

    title: {
        color: theme.palette.primary.light
    },
    titleBar: {
        background:
            'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)'
    }
}));

function ImageSliderModal({ images, currentImage, showModal, MODAL_TYPE }) {
    const classes = useStyles();
    const [index, setIndex] = useState(currentImage);

    return (
        <Dialog
            aria-labelledby="imageslider-modal"
            open
            onClose={() => showModal(MODAL_TYPE.NONE)}
            maxWidth="md"
        >
            <DialogContent>
                <Carousel
                    indicators
                    indicatorContainerProps={{
                        style: {
                            position: 'absolute',
                            bottom: '8px',
                            opacity: '.5'
                        }
                    }}
                    autoPlay={false}
                    images={images}
                    index={index}
                    onChange={idx => {
                        setIndex(idx);
                        // handleScroll();
                    }}
                >
                    {images.map((item, i) => (
                        <div style={{ textAlign: 'center' }}>
                            <img
                                // eslint-disable-next-line react/no-array-index-key
                                key={i}
                                className={classes.sliderImage}
                                src={item}
                                alt=""
                            />
                        </div>
                    ))}
                </Carousel>
                <div className={classes.imageList}>
                    {images.map((item, i) => {
                        return (
                            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                            <img
                                className={`${classes.thumbnailImage} ${
                                    index === i ? 'active' : ''
                                }`}
                                // eslint-disable-next-line react/no-array-index-key
                                key={i}
                                data-key={i}
                                onClick={event => setIndex(parseInt(event.target.dataset.key, 10))}
                                src={item}
                                alt=""
                            />
                        );
                    })}
                </div>
            </DialogContent>
        </Dialog>
    );
}
export default ImageSliderModal;
